$(function () {
  if (!customElements.get('about-brand-effect')) {
    customElements.define(
      'about-brand-effect',
      class aboutBrandEffect extends HTMLElement {
        constructor() {
          super();
        }
        marqueeLeftTimer;
        marqueeSpeed = 1;
        connectedCallback() {
          this.init();
          this.querySelectorAll('.marquee-track').forEach((track) => {
            this.initMarquee(track);
          });
        }

        init() {
          const root = $(this); // 保存当前实例对应的 DOM 元素
          const $tabs = root.find('.tab');
          const $mySwiper = root.find('.mySwiper')[0];
          const $slide = root.find('.swiper-slide');
          let swiper;
          if ($slide.length > 1) {
            swiper = new Swiper($mySwiper, {
              on: {
                slideChange: (swiper) => {
                  // 移除之前的 active 类
                  root.find('.tab.active').removeClass('active');
                  $($tabs[swiper.realIndex]).addClass('active');
                },
              },
            });
          }

          // 使用 jQuery 来绑定事件
          $($tabs).each((index, tab) => {
            $(tab).on('click', (event) => {
              // 移除之前的 active 类
              root.find('.tab.active').removeClass('active');
              // 获取当前 tab 的 data-index 属性
              // 添加 active 类到当前 tab
              $(tab).addClass('active');
              if (swiper) {
                swiper.slideTo($(event.target).data('index'));
              }
            });
          });

          // 初始化位置
          $($tabs[0]).click();
        }
        initMarquee(track) {
          const direction = track.dataset.direction || 'left';
          const pauseType = track.dataset.pauseType || 'smooth';
          const totalTime = track.dataset.totalTime || 15;
          const itemsLength = track.children.length;
          const clone = track.innerHTML;
          track.insertAdjacentHTML('beforeend', clone);
          const computedGap = getComputedStyle(track);
          const trackGap = parseFloat(computedGap.gap);

          requestAnimationFrame(() => {
            const itemsWidth = Array.from(track.children)
              .slice(0, itemsLength)
              .reduce((total, item) => total + item.offsetWidth + trackGap, 0);

            const speed = parseFloat(track.dataset.speed) || 1;
            const duration = totalTime / speed;

            let startX, endX;
            if (direction === 'right') {
              startX = -itemsWidth;
              endX = 0;
            } else {
              startX = 0;
              endX = -itemsWidth;
            }

            gsap.set(track, { x: startX });

            const tl = gsap.to(track, {
              x: endX,
              duration: duration,
              ease: 'none',
              repeat: -1,
              onUpdate: function () {
                const currentX = this.targets()[0]._gsap.x;
                const absX = Math.abs(currentX);

                const shouldReset =
                  direction === 'right'
                    ? currentX >= -1 // 向右滚动即将到达0时
                    : absX >= itemsWidth - 1; // 向左滚动即将超过一组宽度时

                if (shouldReset) {
                  requestAnimationFrame(() => {
                    this.targets()[0].style.transition = 'none';
                    gsap.set(track, { x: startX });
                    this.restart();
                  });
                }
              },
            });

            track.addEventListener('mouseenter', () => {
              if (pauseType === 'immediate') {
                tl.pause();
              } else {
                gsap.to(tl, {
                  timeScale: 0,
                  duration: 1,
                  ease: 'power2.inOut',
                });
              }
            });

            track.addEventListener('mouseleave', () => {
              if (pauseType === 'immediate') {
                tl.resume();
              } else {
                gsap.to(tl, {
                  timeScale: 1,
                  duration: 1,
                  ease: 'power2.inOut',
                });
              }
            });
          });
        }

        // 初始化所有轮
      }
    );
  }
});
